import * as actions from './loader.actions'

const initialState = {
  loading: false,
  title: '',
  subtitle: '',
  messages: [],
  showLoadingBar: false,
  progress: 50,
  activeLoaders: {},
}

const actionsMap = {
  [actions.ADD_LOADER]: (state, action) => ({
    ...state,
    loading: true,
    activeLoaders: {
      ...state.activeLoaders,
      [action.data]: true,
    },
  }),
  [actions.REMOVE_LOADER]: (state, action) => {
    const loaderId = action.data

    let activeLoaders = state.activeLoaders

    delete activeLoaders[loaderId]

    const totalActiveLoaders = Object.keys(activeLoaders).length

    return {
      ...state,
      activeLoaders,
      loading: totalActiveLoaders === 0 ? false : true,
    }
  },
  [actions.UPDATE_LOADER]: (state, action) => {
    const loaderId = action.data

    return {
      ...state,
      activeLoaders: {
        ...state.activeLoaders,
        [loaderId]: {},
      },
    }
  },
  [actions.REMOVE_ALL_LOADERS]: () => {
    return initialState
  },
}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
